'use client';

import React, { useRef } from 'react';
import Icon from '@/components/ui/AppIcon';
import MovieCard, { Movie } from '@/components/ui/MovieCard';

const trendingMovies: Movie[] = [
{ id: 'trend-001', title: 'Dune: Part Two', year: 2024, genre: ['Sci-Fi', 'Adventure'], rating: 4.6, reviewCount: 14820, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1f18a0058-1773050457626.png", posterAlt: 'Desert landscape with dramatic sky for Dune movie', badge: 'trending', runtime: 166, director: 'Denis Villeneuve' },
{ id: 'trend-002', title: 'Oppenheimer', year: 2023, genre: ['Drama', 'History'], rating: 4.8, reviewCount: 22340, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1af72d1bb-1785350644547.png", posterAlt: 'Abstract explosion light patterns representing nuclear science', badge: 'top-rated', runtime: 180, director: 'Christopher Nolan' },
{ id: 'trend-003', title: 'Poor Things', year: 2023, genre: ['Comedy', 'Fantasy'], rating: 4.4, reviewCount: 9870, poster: "https://images.unsplash.com/photo-1733342121953-ab224d06c4bd", posterAlt: 'Surreal colorful mountain landscape for Poor Things film', badge: 'staff-pick', runtime: 141, director: 'Yorgos Lanthimos' },
{ id: 'trend-004', title: 'The Holdovers', year: 2023, genre: ['Drama', 'Comedy'], rating: 4.5, reviewCount: 7230, poster: "https://images.unsplash.com/photo-1525564854165-79321c755ce0", posterAlt: 'Snow covered campus buildings in winter setting', runtime: 133, director: 'Alexander Payne' },
{ id: 'trend-005', title: 'Past Lives', year: 2023, genre: ['Drama', 'Romance'], rating: 4.7, reviewCount: 8910, poster: "https://images.unsplash.com/photo-1472967791158-205626561dd4", posterAlt: 'City skyline at night with romantic atmosphere', badge: 'new', runtime: 106, director: 'Celine Song' },
{ id: 'trend-006', title: 'Mission: Impossible — Dead Reckoning', year: 2023, genre: ['Action', 'Thriller'], rating: 4.2, reviewCount: 18760, poster: "https://images.unsplash.com/photo-1642464513360-d653d934ec61", posterAlt: 'Dramatic mountain landscape with action movie atmosphere', runtime: 163, director: 'Christopher McQuarrie' },
{ id: 'trend-007', title: 'Spider-Man: Across the Spider-Verse', year: 2023, genre: ['Animation', 'Action'], rating: 4.9, reviewCount: 31450, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_16939f843-1772407745504.png", posterAlt: 'Colorful cosmic space scene with vibrant animation style', badge: 'top-rated', runtime: 140, director: 'Joaquim Dos Santos' },
{ id: 'trend-008', title: 'All of Us Strangers', year: 2023, genre: ['Drama', 'Romance'], rating: 4.6, reviewCount: 5430, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_14185f90e-1766513162806.png", posterAlt: 'Melancholic empty apartment hallway with soft lighting', runtime: 105, director: 'Andrew Haigh' }];


export default function TrendingRow() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir === 'left' ? -300 : 300, behavior: 'smooth' });
  };

  return (
    <section className="mt-10">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="w-1 h-5 bg-primary rounded-full" />
          <h2 className="text-lg font-700 text-foreground">Trending This Week</h2>
          <span className="px-2 py-0.5 rounded-full text-xs font-600 badge-trending ml-1">Live</span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => scroll('left')} className="btn-ghost p-2 rounded-lg" aria-label="Scroll left">
            <Icon name="ChevronLeftIcon" size={16} className="text-muted-foreground" />
          </button>
          <button onClick={() => scroll('right')} className="btn-ghost p-2 rounded-lg" aria-label="Scroll right">
            <Icon name="ChevronRightIcon" size={16} className="text-muted-foreground" />
          </button>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex items-start gap-4 overflow-x-auto scrollbar-hide pb-4">
        
        {trendingMovies.map((movie) =>
        <MovieCard key={movie.id} movie={movie} size="md" />
        )}
      </div>
    </section>);

}